// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress-bkg {\r\n  background-color: #2196f3;\r\n  height: 86px;\r\n  opacity: 0.2;\r\n  position: absolute;\r\n  margin: 0 -15px;\n}\n.progress-bkg.compact {\r\n  height: 70px !important;\n}\n.avatar-with-shadow {\r\n  -webkit-box-shadow: 0 0 5px 2px #ff5252;\r\n          box-shadow: 0 0 5px 2px #ff5252;\n}\r\n", ""]);
// Exports
module.exports = exports;
